export type TrackCallToActions = {
  joined?: boolean
  redirectLink: string
  purchased?: boolean
  freeSignUp?: boolean
}

type RedirectLinkProps = {
  isPurchased?: boolean
  isJoined?: boolean
  productHotLink?: string
  trackUrl: string
  internalSalesPageUrl: string | null
}

export const learningTrackCallToActions = ({
  joined,
  redirectLink,
  purchased,
  freeSignUp
}: TrackCallToActions) => {
  if (purchased || (freeSignUp && joined)) {
    return [
      {
        to: redirectLink,
        label: 'home.card_cta.access',
        type: 'primary'
      }
    ]
  }

  if (freeSignUp && !joined) {
    return [
      {
        to: redirectLink,
        label: 'home.card_cta.try_free',
        type: 'success'
      }
    ]
  }

  return [
    {
      to: redirectLink,
      label: 'home.card_cta.to_know',
      type: 'success'
    }
  ]
}

export const getLearningTrackLink = ({
  isPurchased,
  isJoined,
  productHotLink,
  trackUrl,
  internalSalesPageUrl
}: RedirectLinkProps): string => {
  if (!isPurchased && !isJoined) {
    return internalSalesPageUrl || productHotLink || trackUrl
  }

  return trackUrl
}
